const Profile: React.FC = () => {
  return <div>Profile</div>
}

export default Profile
